import React, { useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "../../components/controls/Button";
import { useStylesUiElemment } from "../../St/comps/UseStyle";
import { useTranslation } from "react-i18next";
import { insh as inshst } from "../../Context/InshSt";
import { Scanner } from "@material-ui/icons";

export default function DashboardForm(props) {
  const { rptParams, setRptParams, Branches,
    fetching, viewHandle } = props;

  const { t } = useTranslation(["forms", "translation"]);
  const [style, setStyle] = useState(inshst.custm);
  const clasui = useStylesUiElemment();

  return (
    <React.Fragment>
      <Grid
        container
        style={{
          padding: 10,
          backgroundColor: "#fff",
          borderBottom: "solid 4px #aaa",
        }}
        spacing={1}
      >
        <Grid item lg={2} md={2} sm={2} xs={6}>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            id="datef"
            label="من تاريخ"
            type="date"
            format="YYYY-MM-DD"
            name="dateForm"
            value={rptParams.dateFrom}
            onChange={(e) =>
              setRptParams({ ...rptParams, dateFrom: e.target.value })
            }
          />
        </Grid>

        <Grid item lg={2} md={2} sm={2} xs={6}>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            id="dateT"
            label="إلى تاريخ"
            type="date"
            format="YYYY-MM-DD"
            name="datet"
            value={rptParams.dateTo}
            onChange={(e) =>
              setRptParams({ ...rptParams, dateTo: e.target.value })
            }
          />
        </Grid>

        <Grid item lg={2} md={2} sm={2} xs={6}>
          <Autocomplete
            value={rptParams.branch}
            onChange={(event, newValue) => {
              setRptParams({ ...rptParams, branch: newValue });
            }}
            id="combo-box-demo"
            size="small"
            options={Branches}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.name
            }
            style={{}}
            disableClearable
            renderInput={(params) => (
              <TextField
                {...params}
                InputLabelProps={{ shrink: true }}
                label="الفرع"
                variant="outlined"
              />
            )}
          />
        </Grid>
        <Grid item >
          <Button
            disabled={fetching}
            variant="contained"
            startIcon={<Scanner/>}
            size="large"
            style={
              (inshst.purch.iconBtn ,
                { borderRadius: 0 })
            }
            className={[clasui.button]}
            onClick={() => viewHandle()}
          >
            {t("forms:view")}
          </Button>
        </Grid>

      </Grid>
    </React.Fragment>
  );
}
